/**
 * Representa a view de domnínio personalizado do configurador de limites e notificações de componentes de frequência.
 */
const CREATE_OR_UPDATE = "CreateOrUpdate";

/**
 * Representa a view de estratificações do configurador de limites e notificações de componentes de frequência.
 */
const DELETE = "Delete";

export default {
	CREATE_OR_UPDATE,
	DELETE,
};
